export const TURNSTILE_FEATURE_FLAG_ID = 'turnstile'

export const TURNSTILE_DISABLED_TOKEN = 'ff-turnstile-off'

/** Firestore `featureFlags/hubSidebar` — consolidate admin drawer into hubs. */
export const HUB_SIDEBAR_FEATURE_FLAG_ID = 'hubSidebar'

/** Firestore `featureFlags/assistant` — portal assistant drawer + /ask. */
export const ASSISTANT_FEATURE_FLAG_ID = 'assistant'

/**
 * Staging-gated product flags. The Vite dev server forces these on so local
 * testing (including against production data) is not blocked by Firestore.
 * Hosting builds still read `featureFlags/{id}.enabled`.
 * Turnstile stays out of this set; local hosts already skip that widget.
 */
const LOCAL_DEV_FLAG_IDS = new Set<string>([
  HUB_SIDEBAR_FEATURE_FLAG_ID,
  ASSISTANT_FEATURE_FLAG_ID,
])

export const isFeatureFlagOnInLocalDev = (
  flagId: string,
  isDev: boolean = import.meta.env.DEV,
): boolean => isDev && LOCAL_DEV_FLAG_IDS.has(flagId)

/** Local Vite / Simulator — never mount the Cloudflare widget. */
export const isLocalTurnstileHost = (
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
): boolean => {
  const host = hostname.replace(/^\[|\]$/g, '').toLowerCase()
  return host === 'localhost' || host === '127.0.0.1' || host === '::1'
}

/** Firebase Hosting preview channel: `{site}--pr-{n}-{hash}.web.app`. */
const PR_PREVIEW_HOST =
  /^[a-z0-9-]+--pr-\d+(?:-[a-z0-9]+)?\.(web\.app|firebaseapp\.com)$/

/**
 * PR preview URLs hardcode `featureFlags/turnstile` off.
 * Staging and production hosts still read the stored flag.
 */
export const isTurnstileForcedOff = (
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
): boolean => {
  const host = hostname.replace(/^\[|\]$/g, '').toLowerCase()
  return PR_PREVIEW_HOST.test(host)
}
